<template>
    
    <div class="section" id="carousel">            
      <div class="container-fluid p-0">        
        
        <el-carousel height="350px" :interval="10000">

        <el-carousel-item
            class="article-item background-wave1 p-5">
            <h6 class="title col-12 m-0 d-none d-xl-block">Conteúdo destaque<label>.</label></h6>
            <h3 class="title col-12 col-lg-6 m-0">Como economizar com nuvem<label>?</label></h3>
            <p class="col-12 col-lg-6">
                Uma das principais funções que desempenho atualmente é buscar ter o melhor 
                proveito de tecnologias disponíveis no mercado, de forma eficaz e eficiente.</p>
            <a class="btn btn-primary btn-round btn-md"
                href="https://www.linkedin.com/pulse/como-economizar-com-nuvem-huander-tironi/"
                target="_blank">
                Ler o artigo 
                <i class="now-ui-icons arrows-1_share-66"></i>
            </a>
          </el-carousel-item>
          <el-carousel-item
            class="article-item background-wave1 p-5">
            <h6 class="title col-12 m-0 d-none d-xl-block">Conteúdo destaque<label>.</label></h6>
            <h3 class="title col-12 col-lg-6 m-0">Nuvem: é caro<label>?</label></h3>
            <p class="col-12 col-lg-6">Como funciona a cobrança do serviço de computação em nuvem e como a tecnologia pode ser usada para alavancar seu negócio.</p>
            <a class="btn btn-primary btn-round btn-md"
                href="https://www.linkedin.com/pulse/nuvem-%C3%A9-caro-huander-tironi/"
                target="_blank">
                Ler o artigo 
                <i class="now-ui-icons arrows-1_share-66"></i>
            </a>
          </el-carousel-item>
          <el-carousel-item 
            class="article-item background-wave1 p-5">            
            <h6 class="title col-12 m-0 d-none d-xl-block">Conteúdo destaque<label>.</label></h6>
            <h3 class="title col-12 col-lg-6 m-0">AWS terá faturamento em REAIS<label>.</label></h3>
            <p class="col-12 col-lg-6">
                A AWS está criando a Amazon Serviços Brasil Ltda. A nova filial
                tem como objetivo o faturamento para todas as contas 
                válidas no Brasil em Reais.</p>
            <a class="btn btn-primary btn-round btn-md"
                href="https://www.linkedin.com/pulse/aws-ter%C3%A1-faturamento-em-reais-huander-tironi/"
                target="_blank">
                Ler o artigo 
                <i class="now-ui-icons arrows-1_share-66"></i>
            </a>
          </el-carousel-item>
          
        </el-carousel>
      </div>
    </div>

</template>

<script>
import {
  Button
} from '@/components';
import { Carousel, CarouselItem } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

export default {
    name: 'articles-section',
    components: {
        [Button.name]: Button,
        [Carousel.name]: Carousel,
        [CarouselItem.name]: CarouselItem
    }
}
</script>

<style scoped lang="scss">

.section {
    padding: 0;

    .article-item {
        color: #fff;

        h3 {
            padding-top: 0px!important;
        }

        p {
            line-height: 20px;
        }

        h6 {
            color: #ddd;
        }
    }

    .background-wave1 {
        background-image: url(https://bucket-ctcloud.s3.sa-east-1.amazonaws.com/waves.svg);
        background-size: cover;
    }
}

</style>
